import { render, staticRenderFns } from "./PostAccordionSection.vue?vue&type=template&id=1dc57693&scoped=true&"
import script from "./PostAccordionSection.vue?vue&type=script&lang=js&"
export * from "./PostAccordionSection.vue?vue&type=script&lang=js&"
import style0 from "./PostAccordionSection.vue?vue&type=style&index=0&id=1dc57693&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc57693",
  null
  
)

export default component.exports